// KÖZÖS SZÁMLÁZÁS JELÖLÉSE — a tétel / számla / szolgáltatás nem csak egy fiókra, hanem több fiókra EGYÜTT
// vonatkozik. Három helyen áll (havi áttekintés, Számláim, Szolgáltatásaim), ezért közös.
//
// TÓNUS: tájékoztatás, nem állapot → a katalógus `portalBilling.shared` jele (kék `sky`; az `info` ebben a témában
// zöld, a zöld pedig „siker", ezért nem az). A jelvény a kártya jelvény-sorába ül, a fiók-nevek mellette halvány
// szövegként.
//
// A fiók-NEVEK közül csak azok jönnek a szerverről, amelyekhez a hívónak hozzáférése van; a többi csak
// darabszám (`otherCount` → „+N további fiók"). Idegen fiók nevét a felület SOSEM írja ki — nem is kaphatja.
import type { PortalShared } from '@atlas/contracts';
import { useTranslation } from 'react-i18next';

import { DomainBadge } from '@/components/shared/domain-badge';
import { Text } from '@/components/ui/text';
import { cn } from '@/lib/utils';

export function PortalSharedBadge({
  shared,
  className,
}: {
  /** `null` → nem közös: a komponens nem renderel semmit. */
  shared: PortalShared | null;
  className?: string;
}): JSX.Element | null {
  const { t } = useTranslation();
  if (shared === null) return null;
  const hasNames = shared.visibleAccountNames.length > 0;
  return (
    <div
      data-testid="portal-shared-badge"
      className={cn('flex min-w-0 flex-wrap items-center gap-x-2 gap-y-0.5', className)}
    >
      <DomainBadge
        kind="portalBilling"
        value="shared"
        label={t('portal.billing.shared.title', { count: shared.accountCount })}
      />
      {(hasNames || shared.otherCount > 0) && (
        <Text variant="secondary" as="span" className="min-w-0 break-words">
          {hasNames &&
            t('portal.billing.shared.accounts', { names: shared.visibleAccountNames.join(', ') })}
          {hasNames && shared.otherCount > 0 && ' · '}
          {shared.otherCount > 0 && t('portal.billing.shared.other', { count: shared.otherCount })}
        </Text>
      )}
    </div>
  );
}
